import { makeT } from "@lana-commerce/core/react/translateLocalStatic";

// prettier-ignore
export const T = makeT({
  ru: {
    "Enter your email": "Введите адрес электронной почты",
  },
});
